export default __webpack_public_path__ + "static/media/marauders-map-v4-02-02.6b931cf5.jpg";